import React from 'react';
import styled from 'styled-components';

import { Banner } from '@spotify-internal/encore-creator-web';
import { screenSmMin } from '@spotify-internal/encore-foundation';

import { useBanner } from './lib/useBanner';

export const FundraisingBannerWrapper = styled.div`
  & > * {
    border-radius: 4px;
  }

  @media (max-width: ${screenSmMin}) {
    width: 100vw;
    position: relative;
    /*
     * Push the container to the exact middle of the browser window with left: 50%
     * then pull it back to the left edge with -50vw margin
     */
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;

    & > * {
      border-radius: 0;
    }
  }
`;

export function FundraisingBanner() {
  const { done, hide, success } = useBanner();

  if (hide) return null;

  if (success) {
    return (
      <FundraisingBannerWrapper>
        <Banner variant={Banner.success} onClose={done}>
          <FundraisingSuccess />
        </Banner>
      </FundraisingBannerWrapper>
    );
  }

  return null;
}

function FundraisingSuccess() {
  return <>Your fundraising link has been received</>;
}
